import React,{ Component } from 'react'
import moment from 'moment'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { updateUser, getMetodosEnvio, getProvincias, getCiudades } from "../actions";
import Menu from "../components/user_menu"
;
class MisDatos extends Component{
  
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      alert:"",
      respuesta:'',
      calle:"",
      altura:"",
      piso:"",
      tipo:"",
      pais:"Argentina",
      provincia:"Buenos Aires",
      ciudad:"Ciudad Autónoma de Buenos Aires",
      codpost:"",
      cont_apellido:"",
      cont_nombre:"",
      cont_condicion: "CONSUMIDORFINAL",
      cont_cuitcuil:"",
      cont_telefono:"",
      cont_correo:"",
      cont_empresa: "",
      metodos_envio:[],
      envio:""
    }
    this.enviaDatos = this.enviaDatos.bind(this);
    this.cambia = this.cambia.bind(this)
    this.validaForm = this.validaForm.bind(this)
    this.traeGeo = this.traeGeo.bind(this);
  }

  componentDidMount(){
      if(!this.props.usuario.user){
          this.props.history.push("/login")
        }
        var data = {}
        if(!this.props.usuario.perfil.hasOwnProperty("cargoPerfil")){
            data.cont_apellido=this.props.usuario.perfil.apellido;
            data.cont_nombre = this.props.usuario.perfil.nombre;
            data.cont_correo = this.props.usuario.perfil.correo;
            this.setState(
                data,
                this.props.getProvincias()
                )
        }else{
                console.log("TIENE PERFIL")
                var datos = this.props.usuario.perfil
                datos.alert=""
                this.setState(datos, this.traeGeo());
        }
                
    }
            
    componentDidUpdate(prevProps, prevState){     
        if(prevProps.usuario.contador < this.props.usuario.contador){
            this.setState({loading:false, alert:"Se envio correctamente"})
        }
    }

    traeGeo(){
        this.props.getProvincias()
        if(this.state.provincia!=""){
            this.props.getCiudades(this.state.provincia)
        }
    }

  enviaDatos = (e) => {
    e.preventDefault()
    this.setState({ loading: true }, () => {
        var dataPefil = { calle: this.state.calle, altura: this.state.altura, piso: this.state.piso, tipo: this.state.tipo, pais: this.state.pais, provincia: this.state.provincia, ciudad: this.state.ciudad, codpost: this.state.codpost, cont_apellido: this.state.cont_apellido, cont_nombre: this.state.cont_nombre, cont_condicion: this.state.cont_condicion, cont_cuitcuil: this.state.cont_cuitcuil, cont_telefono: this.state.cont_telefono, cont_correo: this.state.cont_correo, cont_empresa: this.state.cont_empresa, cargoPerfil: true };
        this.props.updateUser(this.props.usuario.user.uid, dataPefil)
      /*const valida = this.validaForm();
      if (valida.resp) {
      } else {
        this.setState({ alert: valida.msj, loading: false });
      }*/
    });
  }
  
  validaForm = () =>{
    if(this.state.calle==""){
      return {
        resp:false,
        msj:"DEBE COMPLETAR LA CALLE"
      }
    } else if (this.state.altura == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA ALTURA"
      }
    } else if (this.state.codpost == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL CODIGO POSTAL"
      }
    } else if (this.state.cont_nombre == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR SU NOMBRE"
      }
    } else if (this.state.cont_apellido == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR SU APELLIDO"
      }
    } else if (this.state.cont_cuitcuil == "" && this.state.cont_condicion!="CONSUMIDORFINAL") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR SU CUIT"
      }
    } else if (this.state.cont_correo == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA DIRECCION DE MAIL"
      }
    } else if (this.state.cont_telefono == "") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR EL TELEFONO"
      }
    } else if (this.state.cont_empresa == "" && this.state.cont_condicion != "CONSUMIDORFINAL") {
      return {
        resp: false,
        msj: "DEBE COMPLETAR LA EMPRESA"
      }
    }else{
      return {
        resp:true,
        msj:"PASO LA VALIDACION"
      }
    }
  }

    cambia = (key,value)=>{
        if(key==="provincia"){
            this.props.getCiudades(value)
        }
        this.setState({[key]:value})
    }



	render(){
        var provincias =[]
        if (this.props.usuario.provincias ){
          var provs = this.props.usuario.provincias;
          provs.sort(function (a, b) {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            return 0;
          });
          provincias = provs.map((provincia,i) =>{
                if(this.state.provincia!="" && this.state.provincia===provincia.nombre){
                    return <option key={i} value={provincia.nombre} >{provincia.nombre}</option>
                }else{
                    return <option key={i} value={provincia.nombre}>{provincia.nombre}</option>
                }
            })
        }

        var ciudades = []
        if (this.props.usuario.ciudades) {
          var ciudadaesSort = this.props.usuario.ciudades;
          ciudadaesSort.sort(function (a, b) {
            if (a.nombre > b.nombre) {
              return 1;
            }
            if (a.nombre < b.nombre) {
              return -1;
            }
            return 0;
          });
          ciudades = ciudadaesSort.map(
              (ciudad, i) => {
              return (
                  <option key={i} value={ciudad.nombre}>
                      {ciudad.nombre}
                </option>
              );
            }
          );
        }


		return <section className="container row mb-5 sombraHead mt-3 clearfix">
        <div className="col-md-4 mb-3">
          <Menu />
        </div>

        <div className="col-md-6 mb-3">
          {this.state.alert != "" && <div className="alert alert-danger" role="alert">
              {this.state.alert}
            </div>}
          <h1 className="display-4">Direccion</h1>
          <form>
            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>Calle</label>
                <input type="text" className="form-control" id="calle" value={this.state.calle} aria-describedby="emailHelp" placeholder="Ingrese el nombre de la calle" onChange={evt => this.cambia("calle", evt.target.value)} />
              </div>
              <div className="col-md-2 mb-3">
                <label>Altura</label>
                <input type="text" className="form-control" id="Altura" value={this.state.altura} placeholder="Altura" onChange={evt => this.cambia("altura", evt.target.value)} />
              </div>
              <div className="col-md-2 mb-3">
                <label>Piso</label>
                <input type="text" className="form-control" id="Piso" value={this.state.piso} placeholder="Piso" onChange={evt => this.cambia("piso", evt.target.value)} />
              </div>
              <div className="col-md-2 mb-3">
                <label>Dpto</label>
                <input type="text" className="form-control" id="Tipo" value={this.state.tipo} placeholder="Tipo" onChange={evt => this.cambia("tipo", evt.target.value)} />
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-3 mb-3">
                <label>Pais</label>
                <select className="form-control form-control-sm" id="Pais" onChange={evt => this.cambia("pais", evt.target.value)}>
                  <option value="Argentina">Argentina</option>
                </select>
              </div>

              <div className="col-md-3 mb-3">
                <label>Provincia</label>
                 <select value={this.state.provincia} className="form-control form-control-sm" id="Provincia" onChange={evt => this.cambia("provincia", evt.target.value)}>
                  <option value="">SELECCIONAR</option>
                  {provincias}
                </select>
              </div>

              <div className="col-md-3 mb-3">
                <label>Ciudad</label>
                <select value={this.state.ciudad} className="form-control form-control-sm" id="Ciudad" onChange={evt => this.cambia("ciudad", evt.target.value)}>
                    <option value="">SELECCIONAR</option>
                    {ciudades}
                </select>
              </div>

              <div className="col-md-3 mb-3">
                <label>Cod.Post</label>
                <input type="text" className="form-control" id="codpost" value={this.state.codpost} placeholder="Codigo Postal" onChange={evt => this.cambia("codpost", evt.target.value)} />
              </div>
            </div>

            <p className="h5">Datos contacto</p>

            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>Nombre</label>
                <input type="text" className="form-control" id="cont_nombre" value={this.state.cont_nombre} placeholder="Ingrese el nombre del contacto" onChange={evt => this.cambia("cont_nombre", evt.target.value)} />
              </div>
              <div className="col-md-6 mb-3">
                <label>Apellido</label>
                <input type="text" className="form-control" id="cont_apellido" value={this.state.cont_apellido} placeholder="Ingrese el apellido del contacto" onChange={evt => this.cambia("cont_apellido", evt.target.value)} />
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>Condición</label>
                <select className="form-control form-control-sm" id="cont_condicion" onChange={evt => this.cambia("cont_condicion", evt.target.value)}>
                  <option value="CONSUMIDORFINAL"> CONSUMIDOR FINAL</option>
                  <option value="RESPONSABLEINSCRIPTO">
                    {" "}
                    RESPONSABLE INSCRIPTO{" "}
                  </option>
                  <option value="EXENTO"> EXENTO </option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label>Cuil/Cuit</label>
                            <input type="text" className="form-control" id="cont_cuitcuil" value={this.state.cont_cuitcuil} placeholder="Ingrese su cuit/cuil" onChange={evt => this.cambia("cont_cuitcuil", evt.target.value)} />
              </div>
            </div>

            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>Empresa</label>
                <input type="text" className="form-control" id="empresa" value={this.state.cont_empresa} placeholder="Ingrese el nombre de la empresa" onChange={evt => this.cambia("cont_empresa", evt.target.value)} />
              </div>
              <div className="col-md-6 mb-3">
                <label>Telefono</label>
                <input type="text" className="form-control" id="cont_telefono" value={this.state.cont_telefono} placeholder="Ingrese el telefono del contacto" onChange={evt => this.cambia("cont_telefono", evt.target.value)} />
              </div>
            </div>
            <div className="form-row">
              <div className="col-md-6 mb-3">
                <label>Correo</label>
                <input type="email" className="form-control" id="cont_correo" value={this.state.cont_correo} aria-describedby="emailHelp" placeholder="Enter email" onChange={evt => this.cambia("cont_correo", evt.target.value)} />
              </div>
            </div>
            {!this.state.loading ? <button type="submit" className="btn btn-primary" onClick={this.enviaDatos}>
                Guardar
              </button> : <h5>AGUARDE UN INSTANTE...</h5>}
          </form>
        </div>
      </section>;
	}

};

const mapStateToProps = (state, ownProps) => {
  return {
      usuario: state.usuario
    }
}

const mapDispatchToProps = dispatch => {
  return {
    updateUser: (u,data) => {
        dispatch(updateUser(u,data));
    },
    getCiudades: (provincia) => {
        dispatch(getCiudades(provincia));
    },
    getProvincias: () => {
        dispatch(getProvincias());
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MisDatos);



// WEBPACK FOOTER //
// ./src/containers/mis_datos.js